module.exports = __webpack_public_path__ + "img/CancelOutlined.8520d7ff.svg";